import React, { useState } from "react"
import { Helmet } from "react-helmet"
import SpinnerLoader from "../components/spinnerLoader"
import useDatabase from "../hooks/useDatabase"
import useModel from "../hooks/useModel"
import Header from "../components/header"
import Layout from "../components/layout"
import ReportLoader from "../components/reportLoader"

const IndexPage = () => {
  const { isLoading: isLoadingDatabase, database } = useDatabase()
  const { isLoading: isLoadingModel, model } = useModel()
  const isLoadingSite = isLoadingDatabase || isLoadingModel
  const [selectedTags, setSelectedTags] = useState([
    "Indie",
    "FPS",
    "Action RPG",
  ])

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Steam ML</title>
        <link rel="canonical" href="https://steam-ml.netlify.com" />
      </Helmet>
      <SpinnerLoader isLoading={isLoadingSite}>
        {!isLoadingSite && (
          <>
            <Header
              selectedTags={selectedTags}
              allTags={database.tags}
              onChangeTags={setSelectedTags}
            />
            <div className="container w-full min-h-screen mx-auto pt-20">
              <ReportLoader
                selectedTags={selectedTags}
                model={model}
                database={database}
              />
            </div>
          </>
        )}
      </SpinnerLoader>
    </Layout>
  )
}

export default IndexPage
